var map = {
	"./3809e232-8b8f-4b5f-927a-7a86c9ebdc3e-min.webp": 8520,
	"./5fb571e2-45a4-43dd-8521-e4d8b458fa86-min.webp": 3675,
	"./824db8fd-79f5-4448-bc47-abdfee7c2d0d-min.webp": 1690,
	"./8db14bbc-6df8-4328-a83b-a2c8e147b3f6-min.webp": 6149,
	"./901aadca-464f-43e6-9b0a-eafb6708dc67-min.webp": 5789,
	"./IMG_6503-min.webp": 5134,
	"./IMG_7818-min.webp": 3136,
	"./ad7ce822-a660-4dcf-8606-d3bd30187937-min.webp": 269,
	"./aeb0a935-53f9-4ed5-b7a9-711f92b8c65a-min.webp": 3977,
	"./nuova-min.webp": 3015,
	"./nuovaa-min.webp": 2776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1929;